import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid2,
} from "@mui/material";
import { PageContext } from "../contexts/PageContext";
import PageHeader from "../components/PageHeader";
import Minibar from "../components/Minibar";
import { downloadBlob, loadOrgModel, saveModel } from "../api/connection";
import { createAsset } from "../models/Asset";
import { showSnackbar } from "../components/UniversalDialog";
import { AssetPreview } from "../components/EditAsset/AssetPreview";
import { ArrowLeft, Save } from "@mui/icons-material";
import { TabSelector } from "../components/TabSelector";
import { AssetModelTreeView } from "../components/EditAsset/AssetModelTreeView";
import { AssetManifestEdit } from "../components/EditAsset/AssetManifestEdit";
import { AssetAnimations } from "../components/EditAsset/AssetAnimations";

export const EditAssetDescriptionPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [asset, setAsset] = useState(createAsset(id));
  const [blob, setBlob] = useState(new Blob());
  const [modelTree, setModelTree] = useState<any>(null);
  const { isLoggedIn, user, setUser, org, setOrg } = useContext(PageContext);
  useEffect(() => {
    const loadAsset = async () => {
      const a = createAsset(id);
      await loadOrgModel(a);
      // console.log({ a });
      setAsset(a);
      const blobData = await downloadBlob(
        "techmage-assets",
        `${a._id}.glb`,
        // 1
        24 * 60 * 60 * 1000
      );
      if (blobData instanceof ArrayBuffer) {
        const b = new Blob([blobData], {
          type: "application/octet-stream",
        });
        setBlob(b);
        setLoading(false);
      } else {
        showSnackbar("Error loading model", "error");
      }
    };
    loadAsset();
  }, [id]);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        {/* page header */}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 0,
            m: 0,
            backgroundColor: "#212121",
            color: "#ECECEC",
            minHeight: "100vh",
          }}
        >
          <Backdrop
            open={loading}
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <PageHeader
            title={`${asset.name}`}
            rightComponent={[
              <Minibar
                minibarItems={[
                  {
                    text: "Back to Asset",
                    icon: <ArrowLeft />,
                    onClick: () => navigate(`/edit-asset/${asset._id}`),
                  },
                  {
                    text: "Save changes",
                    icon: <Save />,
                    onClick: () => saveModel(asset),
                  },
                ]}
                barLength={3}
              />,
            ]}
          />
          <Grid2 container direction="row">
            <Box sx={{ width: "700px", minHeight: "200px" }}>
              <TabSelector
                tabs={{
                  Manifest: {
                    component: (
                      <AssetManifestEdit
                        asset={asset}
                        setAsset={setAsset}
                        model={modelTree}
                      />
                    ),
                  },
                  "Model Tree": {
                    component: (
                      <AssetModelTreeView asset={asset} model={modelTree} />
                    ),
                  },
                  Animations: {
                    component: (
                      <AssetAnimations asset={asset} model={modelTree} />
                    ),
                  },
                }}
              />
            </Box>
            <Box sx={{ flexGrow: 1, height: "calc(100vh - 240px)" }}>
              <AssetPreview
                asset={asset}
                modelBlob={blob}
                setModelTree={setModelTree}
              />
            </Box>
          </Grid2>
        </Box>
      </Box>
    </>
  );
};
